import defaultSettings from '@/settings'
import Cookies from "js-cookie";

const title = defaultSettings.title || '在线服务平台'

export default function getPageTitle(pageTitle) {
  const chooseLanguage = Cookies.get('language')
  if(chooseLanguage === 'en') {
    return `Customer Online Services`
  }else{
    return `在线服务平台`
  }
}
